// What is stuck on this tablet (pilot fix, Batch 5 lane tablet): actions that
// kept failing on the server ("Couldn't send — Try again / Discard") and
// actions someone else saved here, which are never sent under this login.
import { AlertTriangle, UserRound } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { formatRelative } from '@/lib/utils'
import { T } from '@/lib/inventoryFlow/strings'
import type { QueuedAction } from '@/lib/inventoryFlow/offlineQueue'

export function QueueProblems({ failed, held, onRetry, onDiscard }: {
  failed: QueuedAction[]
  held: QueuedAction[]
  onRetry: (id: string) => void
  onDiscard: (id: string) => void
}) {
  if (failed.length === 0 && held.length === 0) return null
  return (
    <div className="space-y-2">
      {failed.length > 0 && (
        <section className="space-y-2 rounded-lg border border-red-300 bg-red-50/60 p-3 dark:border-red-900 dark:bg-red-950/20">
          <div className="flex items-start gap-2">
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-red-700 dark:text-red-300" />
            <div className="min-w-0 text-sm">
              <p className="font-semibold">{T.queueFailedTitle}</p>
              <p className="text-muted-foreground">{T.queueFailedHelp}</p>
            </div>
          </div>
          <ul className="divide-y rounded-lg border bg-background">
            {failed.map((a) => (
              <li key={a.id} className="flex flex-wrap items-center gap-2 p-2.5 text-sm">
                <span className="min-w-0 flex-1">
                  <span className="block font-medium">{a.label}</span>
                  <span className="block text-xs text-muted-foreground">
                    {[T.errServer, formatRelative(a.createdAt)].join(' · ')}
                  </span>
                </span>
                <Button size="sm" onClick={() => onRetry(a.id)}>{T.queueTryAgain}</Button>
                <Button size="sm" variant="ghost" onClick={() => onDiscard(a.id)}>{T.queueDiscard}</Button>
              </li>
            ))}
          </ul>
        </section>
      )}
      {held.length > 0 && (
        <section className="space-y-2 rounded-lg border border-amber-300 bg-amber-50/60 p-3 dark:border-amber-900 dark:bg-amber-950/20">
          <p className="text-sm text-muted-foreground">{T.queueHeldHelp}</p>
          <ul className="divide-y rounded-lg border bg-background">
            {held.map((a) => (
              <li key={a.id} className="flex flex-wrap items-center gap-2 p-2.5 text-sm">
                <UserRound className="h-4 w-4 shrink-0 text-muted-foreground" />
                <span className="min-w-0 flex-1">
                  <span className="block font-medium">{a.label}</span>
                  <span className="block text-xs text-muted-foreground">
                    {[a.userName ? T.queueHeldBy(a.userName) : T.queueHeldSomeone, formatRelative(a.createdAt)].join(' · ')}
                  </span>
                </span>
                <Button size="sm" variant="ghost" onClick={() => onDiscard(a.id)}>{T.queueDiscard}</Button>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  )
}
